import { render, staticRenderFns } from "./expenseHeatmap.vue?vue&type=template&id=bcc1b732"
import script from "./expenseHeatmap.vue?vue&type=script&lang=js"
export * from "./expenseHeatmap.vue?vue&type=script&lang=js"
import style0 from "./expenseHeatmap.vue?vue&type=style&index=0&id=bcc1b732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports